import React from "react";
import CommonRow from "../common-row";
const FiveVideoStories = props => {
  return <CommonRow {...props} />;
};

export default FiveVideoStories;
